"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ipBan = require("@/api/ipBan");
var _permission = require("@/utils/permission");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'IpRateRule',
  data: function data() {
    return {
      listLoading: false,
      tableData: {
        list: [],
        total: 0
      },
      searchForm: {
        uri: '',
        isEnabled: '',
        page: 1,
        limit: 20
      },
      dialogVisible: false,
      submitting: false,
      ruleForm: {
        id: '',
        uri: '',
        limitCount: 5,
        windowSeconds: 60,
        remark: ''
      },
      ruleRules: {
        uri: [{
          required: true,
          message: '请输入接口路径',
          trigger: 'blur'
        }],
        limitCount: [{
          required: true,
          message: '请输入限制次数',
          trigger: 'blur'
        }],
        windowSeconds: [{
          required: true,
          message: '请输入时间窗口',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    dialogTitle: function dialogTitle() {
      return this.ruleForm.id ? '编辑限流规则' : '新增限流规则';
    }
  },
  created: function created() {
    if ((0, _permission.checkPermi)(['platform:ip:ban:rate:rule:list'])) this.loadList();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    loadList: function loadList() {
      var _this = this;
      this.listLoading = true;
      var params = _objectSpread({}, this.searchForm);
      if (params.isEnabled === '') delete params.isEnabled;
      (0, _ipBan.ipRateRuleList)(params).then(function (res) {
        _this.tableData = res;
      }).finally(function () {
        _this.listLoading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.loadList();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        uri: '',
        isEnabled: '',
        page: 1,
        limit: 20
      };
      this.loadList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.loadList();
    },
    handlePageChange: function handlePageChange(page) {
      this.searchForm.page = page;
      this.loadList();
    },
    handleAdd: function handleAdd() {
      this.ruleForm = {
        id: '',
        uri: '',
        limitCount: 5,
        windowSeconds: 60,
        remark: ''
      };
      this.dialogVisible = true;
    },
    handleEdit: function handleEdit(row) {
      this.ruleForm = _objectSpread({}, row);
      this.dialogVisible = true;
    },
    handleSwitch: function handleSwitch(row) {
      var _this2 = this;
      (0, _ipBan.ipRateRuleSwitch)(row.id).then(function () {
        _this2.$message.success('修改成功');
      }).catch(function () {
        row.isEnabled = row.isEnabled === 1 ? 0 : 1;
      });
    },
    handleDelete: function handleDelete(id) {
      var _this3 = this;
      this.$modalSure().then(function () {
        (0, _ipBan.ipRateRuleDelete)(id).then(function () {
          _this3.$message.success('删除成功');
          _this3.loadList();
        });
      });
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (!valid) return;
        _this4.submitting = true;
        var api = _this4.ruleForm.id ? _ipBan.ipRateRuleUpdate : _ipBan.ipRateRuleAdd;
        api(_this4.ruleForm).then(function () {
          _this4.$message.success('操作成功');
          _this4.dialogVisible = false;
          _this4.loadList();
        }).finally(function () {
          _this4.submitting = false;
        });
      });
    },
    handleDialogClose: function handleDialogClose() {
      this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
    }
  }
};